import { useCallback, useRef, useState } from 'react';

import { Input, Slider, DefaultTooltip } from 'twyne-new.ui';

import { useCraftProp } from '@/components/builder/utils';

export default function SliderProperty({ name, min, max, step, orientation, disabled, defaultValue }) {
  const { value, setValue } = useCraftProp(name)
  const [inputRender, setInputRender] = useState(false)
  const inputRef = useRef(null)

  const handleChange = useCallback(value => setValue(value), [setValue])

  const handleDoubleClick = () => {
    setInputRender(true)
    setTimeout(() => {
      inputRef.current?.focus()
    }, 100)
  }

  return <div className='relative w-full flex flex-col items-center'>
    <Slider
      min={min}
      max={max}
      step={step}
      orientation={orientation}
      value={!value && value !== 0 ? defaultValue : value}
      onChange={handleChange}
      tooltip={false}
      disabled={disabled}
      className='z-10'
    />

    {inputRender ? <>
      <Input
        ref={inputRef}
        value={value}
        type='number'
        onChange={e => Number(e.target.value) <= 100 && setValue(e.target.value)}
        onBlur={() => setInputRender(false)}
        onKeyDown={e => e.key === 'Enter' && setInputRender(false)}
        className='py-0 mt-2 w-[25%] text-center text-[80%] absolute z-0'
        variant='ghost'
        max={100}
        min={0}
      />
    </> : <>
      <DefaultTooltip content='Double click to edit'>
        <small className='absolute left-1/2 -translate-x-1/2 top-full mt-0.5' onDoubleClick={handleDoubleClick}>
          <label className='mb-0'>
            {value}
          </label>
        </small>
      </DefaultTooltip>
    </>}
  </div>
}
